import { Component } from '@angular/core';
import { InputUmlComponent } from '../../components/input-uml/input-uml.component';
import { DisplayUmlComponent } from '../../components/display-uml/display-uml.component';

@Component({
  selector: 'app-uml-page',
  standalone: true,
  imports: [InputUmlComponent, DisplayUmlComponent],
  templateUrl: './uml-page.component.html',
  styleUrl: './uml-page.component.scss',
})
export class UmlPageComponent {}
